import { Button, Tag, Upload } from "antd";
import { DocumentItemUI } from "../../../DocumentItems/DocumentItemUI/DocumentItemUI";
import classes from "./ApplicationCreditWorkerUploadDoc.module.css";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { IApplicationCreditWorkerUploadProps } from "../../../../../interfaces/Ui/Application/IApplicationCreditWorkerUploadProps/IApplicationCreditWorkerUploadProps";

export const ApplicationCreditWorkerUploadDoc = ({
  title,
  subtitle,
  onDownloadClick,
  className = "",
  docSigned,
  onUpload,
  ...restProps
}: IApplicationCreditWorkerUploadProps) => {
  const concatClassName = `${classes.document} ${classes.borderColor} ${className}`;

  const statusColor = docSigned ? "green" : "red";
  const statusText = docSigned ? "Подписано клиентом" : "Без подписи";

  const titleChildren = (
    <>
      {title}{" "}
      <Tag className={classes.signInfo} color={statusColor}>
        {statusText}
      </Tag>
    </>
  );

  const subtitleChildren = (
    <>
      <div>{subtitle}</div>

      <div className={classes.docBtns}>
        <Upload
          showUploadList={false}
          customRequest={onUpload}
          className={classes.uploadWrapper}
        >
          <Button className={classes.docBtnsItem}>
            <UploadOutlined width={10} />
            Загрузить
          </Button>
        </Upload>

        <Button className={classes.docBtnsItem}>
          <DownloadOutlined width={10} />
          Скачать
        </Button>
      </div>
    </>
  );

  return (
    <DocumentItemUI
      {...restProps}
      className={concatClassName}
      documentInfoContainerProps={{ className: classes.documentInfo }}
      titleProps={{ className: classes.documentTitle }}
      subtitleProps={{ className: classes.documentFileInfo }}
      title={titleChildren}
      subtitle={subtitleChildren}
    />
  );
};
